import React from "react";

export const VSDIcon = props => (
  <svg
    width="38"
    height="36"
    viewBox="0 0 38 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="8" width="30" height="36" rx="2" fill="#EBEBEB" />
    <path
      d="M8 27h30v7c0 1.1046-.8954 2-2 2H10c-1.10457 0-2-.8954-2-2v-7Z"
      fill="#C8C8C8"
    />
    <path
      d="M29 27V0l7-3e-7C37.1046-3.6e-7 38 .895429 38 2v25h-9Z"
      fill="#DDD"
    />
    <rect y="9" width="29" height="19.5" rx="2" fill="#00754A" />
    <path
      d="m5.46 15.61 1.96 5.5 1.99-5.5h1.29l-2.71 7.14H6.83l-2.72-7.14h1.35Zm6.8088 4.96c.0533.4667.22.8067.5 1.02.2866.2133.71.32 1.27.32.2733 0 .5033-.03.69-.09.1866-.06.3366-.14.45-.24.1133-.1.1933-.2167.24-.35.0466-.14.07-.2867.07-.44 0-.1133-.0167-.2233-.05-.33-.0334-.1133-.0934-.2167-.18-.31-.0867-.0933-.2034-.1733-.35-.24-.1467-.0733-.3334-.13-.56-.17l-.91-.17c-.36-.0667-.68-.15-.96-.25-.28-.1-.5167-.23-.71-.39-.1867-.1667-.33-.3667-.43-.6-.0934-.24-.14-.53-.14-.87 0-.34.0666-.6367.2-.89.14-.2533.33-.4633.57-.63.24-.1733.5233-.3.85-.38.3333-.0867.6933-.13 1.08-.13.4933 0 .9066.0567 1.24.17.3333.1133.6033.2633.81.45.2066.18.3633.39.47.63.1066.24.18.49.22.75l-1.14.18c-.0934-.4-.2567-.6967-.49-.89-.2267-.1933-.59-.29-1.09-.29-.2867 0-.5267.0267-.72.08-.1867.0467-.34.1167-.46.21-.1134.0867-.1967.19-.25.31-.0467.1133-.07.2333-.07.36 0 .3133.0833.5467.25.7.1733.1533.4733.2733.9.36l.99.19c.7533.14 1.3066.38 1.66.72.3533.3333.53.8167.53 1.45 0 .3-.0567.58-.17.84-.1067.2533-.2734.4767-.5.67-.2267.1867-.51.3333-.85.44-.3334.1133-.7234.17-1.17.17-.9134 0-1.63-.19-2.15-.57-.52-.3867-.8067-.9833-.8601-1.79h1.2201Zm8.0255 1.15c.42 0 .7767-.06 1.07-.18.3-.12.5433-.2933.73-.52.1933-.2267.3333-.4967.42-.81.0867-.3133.13-.6667.13-1.06 0-.7867-.1667-1.4-.5-1.84-.3333-.4467-.88-.67-1.64-.67h-1.38v5.08h1.17Zm.2-6.11c.5267 0 1 .0733 1.42.22.42.14.7767.3567 1.07.65.2933.2933.5167.6633.67 1.11.16.44.24.9567.24 1.55s-.0833 1.1167-.25 1.57c-.1667.4467-.4067.8233-.72 1.13-.3133.3-.6967.5267-1.15.68-.4467.1533-.9533.23-1.52.23h-2.34v-7.14h2.58Z"
      fill="#fff"
    />
  </svg>
);
